import type { CadenceTaskFilters } from "../CadenceCalendar.helpers.ts";
import type { Funnel, Lead } from "../../types.ts";

type CadenceFiltersProps = {
  filters: CadenceTaskFilters;
  funnels: Funnel[];
  leads: Lead[];
  onChange: (filters: CadenceTaskFilters) => void;
};

export function CadenceFilters({ filters, funnels, leads, onChange }: CadenceFiltersProps) {
  const activeFunnel = funnels.find((funnel) => funnel.id === filters.funnelId) || null;
  const stages = activeFunnel?.stages || funnels.flatMap((funnel) => funnel.stages);
  const priorities = Array.from(new Set(
    leads.map((lead) => String(lead.priority || "")).filter(Boolean),
  )).sort((a, b) => a.localeCompare(b, "pt-BR"));

  function patch(next: Partial<CadenceTaskFilters>) {
    onChange({ ...filters, ...next });
  }

  return (
    <section className="cadence-filters" aria-label="Filtros da cadencia">
      <label>
        Funil
        <select value={filters.funnelId} onChange={(event) => patch({ funnelId: event.currentTarget.value, stage: "" })}>
          <option value="">Todos</option>
          {funnels.map((funnel) => <option key={funnel.id} value={funnel.id}>{funnel.title}</option>)}
        </select>
      </label>
      <label>
        Etapa
        <select value={filters.stage} onChange={(event) => patch({ stage: event.currentTarget.value })}>
          <option value="">Todas</option>
          {stages.map((stage) => <option key={`${stage.id}-${stage.title}`} value={stage.id}>{stage.title}</option>)}
        </select>
      </label>
      <label>
        Prioridade
        <select value={filters.priority} onChange={(event) => patch({ priority: event.currentTarget.value })}>
          <option value="">Todas</option>
          {priorities.map((priority) => <option key={priority} value={priority}>{priority}</option>)}
        </select>
      </label>
      <label>
        Campanha/curso
        <input value={filters.campaign} onChange={(event) => patch({ campaign: event.currentTarget.value })} />
      </label>
    </section>
  );
}
